import { useEffect, useState } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { api } from '../../../api.ts';
import { TopBar } from '../../../components/TopBar.tsx';
import { BottomNav } from '../../../components/BottomNav.tsx';

const LINKS = [
  { to: '/extra/activite', label: 'Synthèse', end: true },
  { to: '/extra/activite/factures', label: 'Factures' },
  { to: '/extra/activite/clients', label: 'Clients' },
  { to: '/extra/activite/recettes', label: 'Recettes' },
  { to: '/extra/activite/urssaf', label: 'URSSAF' },
  { to: '/extra/activite/verifications', label: 'Vérifications' },
  { to: '/extra/activite/facturation', label: 'Facturation' },
];

export function ExtraBusinessLayout() {
  const [hasProfile, setHasProfile] = useState<boolean | null>(null);
  useEffect(() => {
    api.get('/extras/me').then(() => setHasProfile(true)).catch(() => setHasProfile(false));
  }, []);

  return (
    <div className="app-shell">
      <TopBar title="Mon activité" />
      <div className="screen-content">
        <nav style={{ display: 'flex', gap: 6, overflowX: 'auto', paddingBottom: 4, scrollbarWidth: 'none' }}>
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`} style={{ whiteSpace: 'nowrap' }}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        {hasProfile === false ? (
          <div className="empty-state">
            Créez d'abord votre profil extra. <Link to="/extra" style={{ fontWeight: 800 }}>Créer mon profil</Link>
          </div>
        ) : (
          hasProfile && <Outlet />
        )}
      </div>
      <BottomNav />
    </div>
  );
}
